import { Text } from "@chakra-ui/react";
import { chakraComponents } from "chakra-react-select";
import { useContext, useEffect, useMemo } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { SelectField } from "../../../components/fields/SelectField";
import { AccountContext } from "../../../context/AccountContextComponent";

export const RankingSelect = ({ selectedRanks, setSelectedRanks }) => {
  const { aRankLabel, bRankLabel, cRankLabel, hasModuleTurnedOn } =
    useContext(AccountContext);

  const form = useForm({
    mode: "onChange",
    defaultValues: {
      rank: "",
    },
  });

  useEffect(() => {
    // clear out the value if selectedRanks is empty
    if (!selectedRanks || selectedRanks?.length === 0) {
      form.setValue("rank", []);
    }
  }, [selectedRanks]);

  const rankOptions = useMemo(() => {
    return [
      {
        value: "A",
        label: aRankLabel,
      },
      {
        value: "B",
        label: bRankLabel,
      },
      {
        value: "C",
        label: cRankLabel,
      },
      {
        value: "Unranked",
        label: "Unranked",
      },
    ];
  }, []);

  const hasARank = selectedRanks?.length > 0;

  if (!hasModuleTurnedOn("ABC_RANKING")) {
    return null;
  }

  return (
    <FormProvider {...form}>
      <form
        key={selectedRanks?.length}
        // Prevent form submission on enter key
        onKeyDown={(e) => {
          if (e.key === "Enter") e.preventDefault();
        }}
      >
        <SelectField
          field={{
            id: "rank",
            placeholder: "+ Rank Filter",
            isMulti: true,
          }}
          options={rankOptions}
          onSelectionChange={(e) => {
            console.log(e);
            setSelectedRanks(e);
          }}
          isMulti={true}
          isClearable={false}
          selectProps={{
            variant: "unstyled",
            color: "#3182ce",
            components: !hasARank
              ? {
                  DropdownIndicator: () => null,
                }
              : {
                  Control: ({ children, ...props }) => (
                    <chakraComponents.Control {...props}>
                      {hasARank ? (
                        <Text fontWeight={"bold"} color={"#3182ce"} px={1}>
                          Ranking:
                        </Text>
                      ) : null}
                      {children}
                    </chakraComponents.Control>
                  ),
                },
          }}
          selectStyles={{
            multiValueLabel: (provided) => ({
              ...provided,
              color: "#3182ce",
            }),
            multiValue: (provided) => ({
              ...provided,
              backgroundColor: "#4285F414",
            }),
            multiValueRemove: (provided) => ({
              ...provided,
              color: "#3182ce",
              _hover: {
                color: "#3182ce",
                backgroundColor: "#4285F424",
              },
            }),
            control: (provided) => ({
              ...provided,
              cursor: "pointer",
              padding: "0px 4px 0px 4px",
              borderRadius: "20px",
              // border: "1px solid",
              _hover: {
                bg: "gray.100",
              },
              bg: hasARank && "#4285F414",
              border: hasARank && "1px solid #3182ce",
              color: "#3182ce",
              fontSize: "sm",
            }),
          }}
        />
      </form>
    </FormProvider>
  );
};
